import apiHelper from "./apiHelper";
import { message } from "antd";

export const getUserData = async () => {
  const url = "/user";
  try {
    const response: any = await apiHelper.get(url, {});
    // if (response.data.statusCode === 200) {
    return response.data;
  } catch {
    console.log("Failed to get user");
  }
};

export const deleteUser = async (id: string) => {
  const url = `/user/${id}`;
  const response: any = await apiHelper.delete(url, {});
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  message.error(response.data.message);
  return { error: true };
};

export const getAllApprovedUsers = async () => {
  const url = "/user/all/approved";
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return response.data.data;
  }
  message.error(response.data.message);
  return { error: "Invalid" };
};

export const getAllRejectedUsers = async () => {
  const url = "/user/all/not-approved";
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return response.data.data;
  }
  message.error(response.data.message);
  return { error: "Invalid" };
};

export const getAllUserRequests = async () => {
  const url = "/user/all/requests";
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 200) {
    return response.data.data;
  }
  message.error(response.data.message);
  return { error: "Invalid" };
};

export const updateUser = async (
  id: string,
  body: {
    userType: string;
    organization: string;
    discount: number;
    approved: boolean;
    roleType: string;
  }
) => {
  const url = `/user/account/${id}`;
  const response: any = await apiHelper.patch(url, { ...body });
  if (response.status === 200) {
    message.success(response.data.message);
    return;
  }
  message.error(response.data.message);
  return { error: true };
};

export const updateUserNonAdmin = async (
  id: string,
  body: { firstName: string; lastName: string; marketingEmailPreference: boolean }
) => {
  const url = `/user/${id}`;
  const response: any = await apiHelper.patch(url, { ...body });
  if (response.status === 200) {
    message.success(response.data.message);
    return response;
  }
  message.error(response.data.message);
  return { error: true };
};

export const updateUserDocument = async (body: any) => {
  const url = "/user/document";
  const response: any = await apiHelper.post(url, { ...body });
  if (response.data.statusCode === 201) {
    return { success: true };
  }
  message.error(response.data.message);
  return { error: true };
};

export const changeUserDocument = async (body: any) => {
  const url = "/user/document";
  const response: any = await apiHelper.patch(url, { ...body });
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  message.error(response.data.message);
  return { error: true };
};

export const userDocumentDelete = async (id: any) => {
  const url = `/user/document/${id}`;
  const response: any = await apiHelper.delete(url, {});
  if (response.data.statusCode === 201) {
    return { success: true };
  }
  message.error(response.data.message);
  return { error: true };
};

export const getVoucher = async (id: any) => {
  const url = `/user/voucher/${id}`;
  const response: any = await apiHelper.get(url, {});
  if (response.data.statusCode === 201) {
    return { success: true };
  }
  message.error(response.data.message);
  return { error: true };
};

export const changePersonalData = async (body: any) => {
  const url = "/user/targetGroup";
  const response: any = await apiHelper.patch(url, { ...body });
  if (response.data.statusCode === 201) {
    return { success: true };
  }
  return { error: true };
};

export const updateUserPassword = async (body: {
  currentPassword: string;
  newPassword: string;
}) => {
  const url = "/user/update/password";
  const response: any = await apiHelper.patch(url, { ...body });
  if (response.status !== 200) {
    message.error(response.data.message);
    return;
  }
  return response.data;
};

export const updateUserOnboardingStatus = async (id: string) => {
  const url = `/user/onboarding/${id}`;
  await apiHelper.patch(url, {});
};

export const getAllUsersForSalesDashboard = () => {
  const url = "/user/sales/all";
  return apiHelper.get(url, {});
};

export const updateUserSalesApprovalStatus = async (
  id: string,
  body: {
    approved: boolean;
  }
) => {
  const url = `/user/sales/approve/${id}`;
  const response = (await apiHelper.patch(url, body)) as any;
  if (response.status === 200) {
    message.success("User approval status updated successfully");
    return { success: true };
  }

  message.error("Could not update user approval status");
  return { success: false };
};
